import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditProperty from "./components/pagesComponents/manageProperty/editProperty/EditProperty";
import AuthPublicRoute from "./components/privateRoutes/AuthPrivateRoute";
import PrivateRoute from "./components/privateRoutes/PrivateRoute";
import PublicRoute from "./components/privateRoutes/PublicRoute";
import UserDashBoardCommon from "./components/privateRoutes/UserDashBoard";
import SetUpError from "./components/stripeSetupIndication/SetUpError";
import SetUpSuccess from "./components/stripeSetupIndication/SetUpSuccess";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import ChangePassword from "./pages/adminDashboard/changePassword/changePassword";
import ViewMore from "./pages/adminDashboard/dashboard/viewMore/viewMore";
import Settings from "./pages/adminDashboard/dashboardSettings";
import Details from "./pages/adminDashboard/organizations/details/details";
import Organizations from "./pages/adminDashboard/organizations/organizations/organizations";
import ViewProperty from "./pages/adminDashboard/organizations/property";
import TipTransactionDetail from "./pages/adminDashboard/organizations/property/tipTransactionDetail";
import ViewAssignedProperties from "./pages/adminDashboard/organizations/property/view-assigned-properties";
import Partners from "./pages/adminDashboard/partners/partners";
import ConversionTracking from "./pages/adminDashboard/reporting/conversionTracking/conversionTracking";
import EscrowBalances from "./pages/adminDashboard/reporting/escrowBalances/escrowBalances";
import PayoutTransactions from "./pages/adminDashboard/reporting/payoutTransactions/payoutTransaction";
import Reporting from "./pages/adminDashboard/reporting/reporting";
import Reviews from "./pages/adminDashboard/reporting/reviews/reviews";
import Service from "./pages/adminDashboard/service/service";
import Tippers from "./pages/adminDashboard/tippers/tippers/tippers";
import ViewTips from "./pages/adminDashboard/tippers/viewTips/viewTips";
import ForgotPassword from "./pages/auth/forgotPassword";
import Login from "./pages/auth/login";
import ResetPassword from "./pages/auth/resetPassword";
import RedirectAsAdminPage from "./pages/redirectAsAdminPage";
import ManageProperties from "./pages/userDashboard/manageProperties/ManageProperties";
import ManageViewProperty from "./pages/userDashboard/manageProperties/property";
import ManagePropertyViewTip from "./pages/userDashboard/manageProperties/property/tipTransactionDetail";
import Scoreboard from "./pages/userDashboard/manageProperties/property/scoreboard";
import ManageAssignedProperties from "./pages/userDashboard/manageProperties/property/view-assigned-properties";
import ManagerAccounts from "./pages/userDashboard/managerAccounts";
import PaymentManagement from "./pages/userDashboard/paymentManagement";
import Profile from "./pages/userDashboard/profile";
import QRCodeAndLinks from "./pages/userDashboard/qrCodeAndLink";
import ReportAutomation from "./pages/userDashboard/reportAutomation";
import Signs from "./pages/userDashboard/signs";
import "./scss/App.scss";
import Customize from "./pages/userDashboard/customize";
import TippingExperience from "./pages/tippingExperience";
import Help from "./pages/userDashboard/help/help";
// import ErrorTestComponent from "./components/errorTest/ErrorTestComponent";

const App = () => {
  return (
    <div className="App">
      <Routes>
        {/* Auth Routes */}
        <Route
          index
          element={
            <AuthPublicRoute>
              <Login />
            </AuthPublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <AuthPublicRoute>
              <ForgotPassword />
            </AuthPublicRoute>
          }
        />
        <Route
          path="/redirect-as-admin-page/:token"
          element={
            <PublicRoute>
              <RedirectAsAdminPage />
            </PublicRoute>
          }
        />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/set-password/:token" element={<ResetPassword />} />
        {/* Dashboard Routes */}
        <Route
          path="/:uuid?/dashboard"
          element={
            <PrivateRoute>
              <UserDashBoardCommon />
            </PrivateRoute>
          }
        />
        <Route
          path="/tipping-experience"
          element={
            <PrivateRoute>
              <TippingExperience />
            </PrivateRoute>
          }
        />
        <Route path="/dashboard/all-tips" element={<ViewMore />} />
        {/* Service-categories Route we don't need anymore*/}
        {/* <Route path="/service-categories" element={<ServiceCategories />} /> */}
        {/* Service Routes */}
        <Route path="/service" element={<Service />} />
        {/* Organizations Routes */}
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/reporting/conversion-tracking" element={<ConversionTracking />} />
        <Route path="/reporting/escrow-balance" element={<EscrowBalances />} />
        <Route path="/reporting/payout-transactions" element={<PayoutTransactions />} />

        <Route path="/organizations/view/:uuid" element={<Details />} />
        <Route
          path="/organizations/view/:id/property/view/:id"
          element={<ViewProperty />}
        />
        <Route
          path="/organizations/view-tip-transactions"
          element={<ManagePropertyViewTip />}
        />
        <Route
          path="organizations/view-assigned-properties"
          element={<ViewAssignedProperties />}
        />
        <Route
          path="organizations/tip-transaction-detail"
          element={<TipTransactionDetail />}
        />
        {/* Partner Routes */}
        <Route path="/partners" element={<Partners />} />
        <Route path="/:uuid?/reporting" element={<Reporting />} />
        <Route path="/:uuid?/reporting/reviews" element={<Reviews />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/:uuid?/change-password" element={<ChangePassword />} />
        {/* Tipplers Routes */}
        <Route path="/tippers" element={<Tippers />} />
        <Route path="/tippers/view-tips/:tip_uuid" element={<ViewTips />} />
        {/* reporting Routes */}
        {/* <Route path="/reporting" element={<Reporting />} /> */}
        {/* User-Dashboard Routes -> Manage Properties */}
        <Route
          path="/:uuid?/manage-properties"
          element={<ManageProperties />}
        />
        <Route
          path="/:uuid?/manage-properties/edit/:id"
          element={<EditProperty />}
        />
        <Route
          path="/:uuid?/manage-properties/view-property/:id"
          element={<ManageViewProperty />}
        />{" "}
        <Route
          path="/:uuid?/organizations/view-property/:id"
          element={<ManageViewProperty />}
        />
        <Route
          path="/organizations/view-assigned-properties/:id"
          element={<ManageAssignedProperties />}
        />
        <Route
          path="/:uuid?/view-assigned-properties/:id"
          element={<ManageAssignedProperties />}
        />
        <Route
          path="/:uuid?/manager-accounts/view-assigned-properties/:id"
          element={<ManageAssignedProperties />}
        />
        <Route
          path="/:uuid?/manage-properties/view-property-tips/view-tip-transactions"
          element={<ManagePropertyViewTip />}
        />
        <Route
          path="/:uuid?/manage-properties/scoreboard/:id"
          element={<Scoreboard />}
        />
        <Route path="/scoreboard/:id" element={<Scoreboard />} />
        <Route path="/:uuid/scoreboard/:id" element={<Scoreboard />} />
        <Route path="/public/:id" element={<Scoreboard />} />
        <Route path="/:uuid/public/:id" element={<Scoreboard />} />
        <Route path="/:uuid?/manager-accounts" element={<ManagerAccounts />} />
        <Route path="/:uuid?/QR-Codes-&-links" element={<QRCodeAndLinks />} />
        <Route path="/:uuid?/signs" element={<Signs />} />
        <Route path="/:uuid?/profile" element={<Profile />} />
        <Route
          path="/:uuid?/reporting-automation"
          element={<ReportAutomation />}
        />
        <Route
          path="/:uuid?/payout-settings"
          element={<PaymentManagement />}
        />
        <Route
          path="/:uuid?/customize"
          element={<Customize />}
        />
        <Route
          path="/:uuid?/help"
          element={<Help />}
        />

        {/* <Route path="/success" element={<Success />} /> */}
        {/* <Route path="/reject" element={<Reject />} /> */}
        <Route path="*" element={<PageNotFound />} />
        <Route path="/setup" element={<SetUpSuccess />} />
        <Route path="/setup-error" element={<SetUpError />} />
        {/* <Route path="/bugsnag-error" element={<ErrorTestComponent />} /> */}
      </Routes>
      <ToastContainer autoClose={false} newestOnTop />
      {/* <ErrorTestComponent /> */}
    </div>
  );
};

export default App;
